// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.energy-productivity-container {
    height: 608px;
}

.energy-productivity-title {
    font-family: "Roboto Condensed", arial, sans-serif;
}

.energy-productivity-asset-filter::part(base),
.energy-productivity-asset-filter::part(list) {
    min-height: 30px;
}

.energy-productivity-asset-filter::part(part-default) {
    font-size: 14px;
    line-height: 1.1;
    padding-top: 4px;
    padding-bottom: 4px;
}

.energy-productivity-donut-canvas {
    height: 250px;
}

.energy-productivity-activity-table th,
.energy-productivity-activity-table td {
    border-color: #e5e7eb;
}

.energy-productivity-legend-swatch {
    background-color: #06f;
}

.energy-productivity-empty-state-icon {
    --cat-icon-fill: #6b7280;
    --cat-icon-height: 36px;
    --cat-icon-width: 36px;
}
`, "",{"version":3,"sources":["webpack://./src/components/EnergyProductivity/EnergyProductivity.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI,kDAAkD;AACtD;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;AAC1B","sourcesContent":[".energy-productivity-container {\n    height: 608px;\n}\n\n.energy-productivity-title {\n    font-family: \"Roboto Condensed\", arial, sans-serif;\n}\n\n.energy-productivity-asset-filter::part(base),\n.energy-productivity-asset-filter::part(list) {\n    min-height: 30px;\n}\n\n.energy-productivity-asset-filter::part(part-default) {\n    font-size: 14px;\n    line-height: 1.1;\n    padding-top: 4px;\n    padding-bottom: 4px;\n}\n\n.energy-productivity-donut-canvas {\n    height: 250px;\n}\n\n.energy-productivity-activity-table th,\n.energy-productivity-activity-table td {\n    border-color: #e5e7eb;\n}\n\n.energy-productivity-legend-swatch {\n    background-color: #06f;\n}\n\n.energy-productivity-empty-state-icon {\n    --cat-icon-fill: #6b7280;\n    --cat-icon-height: 36px;\n    --cat-icon-width: 36px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
